const routes = {
    home: '/',
    township: '/commune',
    story: '/commune/histoire',
    geography: '/commune/geographie',
    elected: '/commune/elus',
    council: '/commune/conseil-municipal',
    project: '/projets/liste',
    partner: 'projets/partenaires',
    association: 'projets/associations',
    tourism: 'tourisme/activites',
    leisure: 'tourisme/loisirs',
    contact: '/contact'
};

export default routes;